import React from 'react'
import './LinkFooterBlock.css'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import ButtonLeft from './ButtonLeft'

import { RightSvg } from './SVGarr'

const LinkFooterBlock = ( props ) => {
  return(
    <React.Fragment>
    { props.items.filter( (item) => item.url === `/home/${props.match.params.block}` ).map( (item, index) => 
      <React.Fragment key={index}>
        <ReactCSSTransitionGroup
        transitionName="imgTransition"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}>
          <div className="LinkFooterBlock">
            <ButtonLeft url='/' />
            {item.svg}
            <div className="LFBlabel"> {props.t(item.label)} </div>  
            <Link to={item.urlto} className="arrovRight" > {RightSvg} </Link>
          </div>
          <div className="LFBtext" >
            {props.t(item.text)}
          </div>
        </ReactCSSTransitionGroup>
      </React.Fragment>
    )}
    </React.Fragment>
  )
}

export default translate('translations')(LinkFooterBlock)


// WEBPACK FOOTER //
// ./src/components/LinkFooterBlock.jsx